<template>
  <v-tooltip v-bind="$attrs">
    <template v-slot:activator="{ on, attrs }">
      <v-icon :small="small" :size="iconSize" :color="iconColor" :class="iClass" v-bind="attrs" v-on="on">
        <slot></slot>
      </v-icon>
    </template>
    <span v-if="html" v-html="message"/>
    <span v-else="html">{{ message }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "TooltipIcon",
  props: {
    message: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: true
    },
    iconSize: {
      type: Number,
      required: false
    },
    iconColor: {
      type: String,
      required: false
    },
    iconClass: {
      type: String,
      default: "",
      required: false
    },
    forceEnabled: {
      type: Boolean,
      required: false
    },
    showArrow: {
      type: Boolean,
      required: false
    },
    html: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    iClass(): string {
      return this.forceEnabled ? this.iconClass + " forced-enabed" : this.iconClass;
    }
  }
});
</script>

<style scoped>
.forced-enabed {
  pointer-events: all;
}
</style>
